export const setLastSelectedProduct = (product) => (dispatch, getState) => {
    dispatch({ type: 'SET_LAST_SELECTED_PRODUCT', product})
}

export const setLastRouteId = (routeId) => (dispatch, getState) => {
    console.log('ROUTEE', routeId)
    // dispatch({ type: 'SET_LAST_ROUTE_ID', routeId})
}